package com.dualremotetest

// GENERATED by tools/gen_stagedata.py – do not edit by hand; see docs/STAGE_SOURCES.md.
//
// The 35 stages of the Famicom Battle City (1985), in the ROM's own order and encoding, decoded from the stage table at
// $F07A of "Battle City (J) [!]" as extracted in cyneprepou4uk/NES-Games-Disassembly (incbin/stages/stage_NN.bin).
// One hex digit per 16×16-px block, 13 rows of 13 blocks:
//   0 right-half brick  1 bottom-half brick  2 left-half brick  3 top-half brick  4 brick
//   5 right-half steel  6 bottom-half steel  7 left-half steel  8 top-half steel  9 steel
//   A water  B forest  C ice  D-F empty
// As in the original, the game draws the HQ fort itself over blocks col 5-7 / row 11-12 (stages 10 and 21 carry other
// data there that never shows), and clears a spawn point's 16×16 block when a tank spawns on it (stages 5, 12, 15,
// 16 and 32 have terrain on a spawn block).
// Rosters: the ROM's EntityTypeTable $E4EC and StageEnemyCountTable $E578, expanded in spawn order.
//   B basic  F fast  P power  A armor (4 hits)

object StageData {
    const val STAGES = 35

    val TERRAIN: List<List<String>> = listOf(
        listOf( // Stage 1
            "DDDDDDDDDDDDD",
            "D4D4D4D4D4D4D",
            "D4D4D4D4D4D4D",
            "D4D4D494D4D4D",
            "D4D4D3D3D4D4D",
            "D3D3D1D1D3D3D",
            "1D11D3D3D11D1",
            "8D33D1D1D33D8",
            "D1D1D444D1D1D",
            "D4D4D4D4D4D4D",
            "D4D4D3D3D4D4D",
            "D4D4DDDDD4D4D",
            "DDDDDDDDDDDDD",
        ),
        listOf( // Stage 2
            "DDD9DDD9DDDDD",
            "D4D9DDD4D4D4D",
            "D4DDDD44D494D",
            "DDD4DDDDD9DDD",
            "BDD4DD9DD4B49",
            "BBDDD4DD9DBDD",
            "D444BBB9DDB4D",
            "DDD9B4D4D4D4D",
            "94D9D4D4DDD4D",
            "D4D4D444D494D",
            "D4D4D444DDDDD",
            "D4DDDDDDD4D4D",
            "D4D4DDDDD444D",
        ),
        listOf( // Stage 3
            "DDDD4DDD4DDDD",
            "DBBB4DDDDD666",
            "4BBBDDDDDDDDD",
            "BBBBDDD4D4442",
            "BBBB4443D4D0D",
            "BBBBDD4DDDD0D",
            "DBDDDD999DDBD",
            "D1D1DDDDDBBBB",
            "420420333BBBB",
            "DDDDD4D11BBBB",
            "4DD7DDD33BBBD",
            "44D7DDDDDBBBD",
            "944DDDDDD4DDD",
        ),
        listOf( // Stage 4
            "DBBDDDDDDDDBD",
            "BBDD14411DDDB",
            "BDD04444441D8",
            "8DD444444442D",
            "DD03DDD344D2D",
            "AD0D7D7D42DDD",
            "DD4D11DD42DAA",
            "DD44444444DDD",
            "D0444444442DD",
            "D3344444433DD",
            "D4413443144DB",
            "BD33DDDD33DBB",
            "9BDDDDDDDDBB9",
        ),
        listOf( // Stage 5
            "DDDD444DDDDDD",
            "6D1D4DDD889DD",
            "9D4DDD4DDDDDD",
            "4D444D44DAADA",
            "3DDD3DDDDADDD",
            "DD1DAADAAAD44",
            "44DDA4D42DDDD",
            "DDDDADDDDD57D",
            "AAADAD9D4D5DD",
            "DDD11DDDDD544",
            "DDDD433341DDD",
            "443DDDDDD34DD",
            "3DDDDDDDDDDDD",
        ),
        listOf( // Stage 6
            "DDDDD0D2BBDDD",
            "D25D2DDD0B20B",
            "D25D2D4D0B20B",
            "D4DD4D9D4BD4B",
            "DDD08D4D37DBB",
            "442DDB4BDD044",
            "DDDD0BBB2DDDD",
            "944D3BBB30449",
            "888D1DBD1D888",
            "D4DD4DDD4DDDD",
            "D42DD3D3DD04B",
            "DD3DDDDDDDBBB",
            "DD1DDDDDDD1BB",
        ),
        listOf( // Stage 7
            "DDDDDDD88DDDD",
            "DD9888DDDD9DD",
            "DD9DDDBD899DD",
            "D9DDDB9DDD9DD",
            "DDDDB99DDD89D",
            "D9DB999D9DDDD",
            "D5D99DDD99DDD",
            "7DDD9D999DD5D",
            "D59DDD99BDD9D",
            "D9DDDD9BDD99D",
            "D889DDBDD9DDD",
            "DDDDDDDDD8D69",
            "66DDDDDDDDDDD",
        ),
        listOf( // Stage 8
            "DD4DD4D1D4DDD",
            "B444D4D6D42DD",
            "BBBDD3D4D3D02",
            "BAAAAAAAAAADA",
            "D4DDDD11DDDDD",
            "DD4DD04434388",
            "44D4D044B4664",
            "DDD9D6DBBBBDD",
            "AADAAAAADAAAA",
            "BBD0DD11DDDDD",
            "BB4D2DD0D614D",
            "B64D2DDDD3D4D",
            "DDDDDDDDD1D3D",
        ),
        listOf( // Stage 9
            "DDD4DDDDD6BDD",
            "4DDDDD6B597D4",
            "DDD6B597D8BDD",
            "DD597D8BDDDDD",
            "DDD8BDDDDDDDD",
            "DDDB6BDB6BDDD",
            "94D597D597D49",
            "DDDB8BDB8BDDD",
            "DDDD6DDD6DDDD",
            "4DD597D597DD4",
            "4DDB8BDB8BDD4",
            "DD1DDDDDDD1DD",
            "DD44DDDDD44DD",
        ),
        listOf( // Stage 10
            "DDDDDDDDDDDDD",
            "D034DDDDDD432",
            "03DD4DBBD4DD0",
            "4DDD4BBBB4DD0",
            "4DD04B99B42D4",
            "0114AAAAAA444",
            "D444994994442",
            "DD449D4D9442D",
            "DD4444444442D",
            "4B333993333B4",
            "4BBBBBBBBBBB4",
            "DDBBB111BBBBD",
            "DDD2D4D4DD2DD",
        ),
        listOf( // Stage 11
            "DDDDD9D4D44DD",
            "D04444D4DDDDD",
            "DDD2D4D44DBBB",
            "D0DDDDD9DBBBB",
            "D0D444944BB39",
            "D3339DD4DBBD0",
            "0444D9BBBBBDD",
            "DDD9DDBBBBB4D",
            "94DBBBB9BBB4D",
            "04BBBBBDDDD42",
            "D4BBDDDD8444D",
            "DDBBDDDDD4D0D",
            "D1BBDDDDDDDDD",
        ),
        listOf( // Stage 12
            "DDDDDD4444DDD",
            "D4441D1DD4DDD",
            "DDDD4D3DDDD44",
            "DAAAAAD42DD48",
            "DD666AD4D974D",
            "4D444AAADA44D",
            "DDDD9ADDDA8DD",
            "AAADAA44DADDD",
            "DDDDD488DAAAD",
            "444DDDDDDDDDD",
            "DD4D88DDD44D0",
            "4DDDDDDDD4DD4",
            "DDDDDDDDDDDDD",
        ),
        listOf( // Stage 13
            "DDDD1DDD1DDDD",
            "D4444DDD4444D",
            "D4DDDD4DDDD9D",
            "D9D43DDD34D44",
            "D4D2B696B0D94",
            "D3DDBBBBBDD84",
            "46DDBBBBBDD14",
            "49D2B898B0D4D",
            "44D41DDD14D9D",
            "49DDDD4DDDD4D",
            "44444DDD44499",
            "44DD3DDD3DD4D",
            "44DDDDDDDDDDD",
        ),
        listOf( // Stage 14
            "DDDDDDDDDDDDD",
            "BBDD14441DDBB",
            "BDD0444442DDB",
            "DDD44B4B44DDD",
            "DDD4BB4BB4DDD",
            "BDD4444444DDB",
            "BBDD4B4B4DDBB",
            "AAAD44444DAAA",
            "DDDD00000DDDD",
            "DDDD22222DDDD",
            "555DDDDDDD777",
            "222DDDDDDD000",
            "7775DDDDD7555",
        ),
        listOf( // Stage 15
            "DDDD44DD4DDDD",
            "DBB44DDD4DDDD",
            "BBBBBBBB44DDD",
            "B84B444BBBB49",
            "BB4BBB8BB474D",
            "DBB46BBBB4D4D",
            "D44444BB442BB",
            "5844DDD43DDDB",
            "D4D4D613BB42B",
            "D4DD043BB4DDB",
            "D44203BB1B4BB",
            "DD4DBDDD4B3BD",
            "DD3DBDDDDBBBD",
        ),
        listOf( // Stage 16
            "DDDDDDDDDDDDD",
            "DD9B9DDDDDDDD",
            "DDDBDB6DDDDDD",
            "DBDDDDB1DDDDD",
            "DBBDDBDB6DDDD",
            "DBDBDBDDB1DDD",
            "DBDDBDDDBB6DD",
            "DDBDDDDBBBB1D",
            "DDDBDDBDBBBBD",
            "4DDDDDBDDBBB9",
            "44DDDDDBDBBBB",
            "944DDDDDBDBBB",
            "9944DDDDBDDBB",
        ),
        listOf( // Stage 17
            "DDDD1DDDDD1DD",
            "D4D44DDCCC44D",
            "D4DD4D9CCCCCD",
            "CCC74DD4CCCCD",
            "CCCCCC4402DDD",
            "DD5CCCC402D88",
            "4444CCCCCCC44",
            "DDD44CCCC7DDD",
            "D444DCCC44D4D",
            "CCC4CDDDD4D4D",
            "CCCCC8D8DD14D",
            "4CCCCDDDD4DDD",
            "447DDDDDD4D4D",
        ),
        listOf( // Stage 18
            "DDDDDDDD999BD",
            "D4DDDDDD9DD9D",
            "4B4DDD4444D9D",
            "D4B4DD4DB499D",
            "DD4DB94BD4DDD",
            "DDDD9D4944DDD",
            "DD4494D9DDDDD",
            "DD4DB49BDDDDD",
            "999BD4DD44DDD",
            "9D4444DD499DD",
            "9DD9DDDDD944D",
            "B999DDDDDD499",
            "DDDDDDDDDDD99",
        ),
        listOf( // Stage 19
            "D4D4D4D4D4D4D",
            "D4D4D4D4D4D4D",
            "D8D8D8D8D8D8D",
            "1D1D4DDD4D1D1",
            "4D434D4D434D4",
            "8D8D9D8D9D8D8",
            "BBDD4DBD4DDBB",
            "BBBB43B34BBBB",
            "BBBBBBBBBBBBB",
            "1D1D4BBB4D1D1",
            "D4D4DDBDD4D4D",
            "D4D4DDDDD4D4D",
            "D3D3DDDDD3D3D",
        ),
        listOf( // Stage 20
            "DDDAD4DD4D4DD",
            "DDDDDDDD4D9DD",
            "DDDAD19D4D4DD",
            "8D4AD9D13D4DD",
            "DD4ADDD4DDDDD",
            "4D4AADAAAADD4",
            "DDD1DDDBDAD88",
            "4404D9BBBAD11",
            "3D0DD4BBBAD4D",
            "D6DDD4DBDADBD",
            "D4D6D333DDBBB",
            "D4D4DDDDDABBB",
            "DDDDDDDDDADBD",
        ),
        listOf( // Stage 21
            "DDD111DD1DDDD",
            "D144444444DDD",
            "DBBBBBBBB44DD",
            "BBDDDDDDBB44D",
            "BD9DD9DDDBBBD",
            "BD9DD9DDDBBBD",
            "BDDBDDDDBB442",
            "BBBBBBBBB4442",
            "4BB44BBB4444D",
            "D4444444444D9",
            "9D494444442D9",
            "D943944444999",
            "DDDDDDDDDDDDD",
        ),
        listOf( // Stage 22
            "DDDDDBDDDDDDD",
            "DDDDB9BDDDDDD",
            "DDBDDBDDBBDDD",
            "DB4BDDDB44BDD",
            "DDB4BDDDBBDDB",
            "BDDBDDBDDDDB9",
            "4BDDDB9BDDBDB",
            "94BDDDBDDB9BD",
            "4BDDBDDDBDBDD",
            "BDDB4BDB4BDDD",
            "DDDB4BDDBDDBD",
            "DBDDBDDDDDB9B",
            "B9BDDDDDDB4BD",
        ),
        listOf( // Stage 23
            "DDDDDDDDDDDDD",
            "DDDDD99DDDDDD",
            "DDDDDD9DDDDDD",
            "D99BB494BB99D",
            "DDD9BB9BB9DDD",
            "BDDD9BBB9DDDB",
            "9BDDDBBBDDDB9",
            "BDDD68B86DDDB",
            "DDDD9D6D9DDDD",
            "DDD9DD9DD9DDD",
            "DDDDDDDDDDDDD",
            "DDDDDDDDDDDDD",
            "DD9DDDDDDD9DD",
        ),
        listOf( // Stage 24
            "DD9D48DDDD0DD",
            "DD4D4BD3444DD",
            "DBBD4B02DDD99",
            "BBBBBB444D04D",
            "DDBB1184D0430",
            "48D133DDD43D0",
            "0D14CCCCCCCCC",
            "0D3DCCCCCCCCC",
            "DD9DCCCCCCCCC",
            "4D4DCCCCCCCCC",
            "0D4DCCCCCCCCC",
            "0D4DDDDDCCCCC",
            "DD3DDDDDDCCCC",
        ),
        listOf( // Stage 25
            "DDD9D4D4D4D9D",
            "D4D4DDDDD9DDD",
            "D4D4DD9DD9D99",
            "D4DDD4D94DDD9",
            "DDDD44D44D9DD",
            "DD9D4DD44D44D",
            "9D9DD4D9DD94D",
            "DD44D4DDD49DD",
            "D944D44D44DD4",
            "D4DDD49DDDD44",
            "DDD4D449D9DD4",
            "4D44DDDDD49DD",
            "4D4DDDDDD444D",
        ),
        listOf( // Stage 26
            "DDAADDDDDDDDD",
            "6DDABD2DDDDDD",
            "B6DDDD7D2DAAD",
            "BBD810DD7BADD",
            "BBBDD910DDDD6",
            "BB86D0D91DD6B",
            "B8DD39D0D8DBB",
            "DDDDD239DDBBB",
            "DDAB5DD2368BB",
            "DAAD0D5DDDDDB",
            "DDDDDD0DBADD8",
            "9DDDDDDDDAADD",
            "99DDDDDDDDDD9",
        ),
        listOf( // Stage 27
            "DDDD9DDDDDDDD",
            "99DD9DD99DDDD",
            "D9DD9DDD9D99B",
            "D9DD999DBD9DD",
            "D4DDDD9D999DD",
            "B99D94944DDDD",
            "DD9B9BDD4DD99",
            "DD9DDBDD9DD9D",
            "DD4DD9DD9949D",
            "B999BB499D49D",
            "DDD4DDDDBBD4D",
            "DDD9DDDDDBD4D",
            "DDD9DDDDD9D4D",
        ),
        listOf( // Stage 28
            "DDDDDDDDDD57D",
            "DDDDDD6DDD9DD",
            "DDDDD1B1D42DD",
            "DDDD6BBB642DD",
            "DDD1BBCBB42DD",
            "DD6BBCCCBB2DD",
            "D1BBCCCCCBB1D",
            "6BBCCCCCCCBB6",
            "BBCCCCCCCCCBB",
            "DBCCCCCCCCCBD",
            "DBCCCCCCCCCBD",
            "DBCCCDDDCCCBD",
            "DBCCDDDDDCCBD",
        ),
        listOf( // Stage 29
            "DDDDDDDDDD4DD",
            "D4AAD9D4DDDDD",
            "DDAA4BBBAAD9D",
            "DDDDDBBBAA4DD",
            "D9DDAADBDDDDD",
            "BB4DAA9DDDD4D",
            "BBBDDDDDD9DD9",
            "D4AAD4DDDDDDD",
            "9DAABBAABBD4D",
            "DDDDBDAABBAAD",
            "DDD9BDDDBBAAD",
            "DD4D4DDDDDDDD",
            "4DDDDDDDD49DD",
        ),
        listOf( // Stage 30
            "DDDDDDDDDDDDD",
            "DDDDD11DDD6DD",
            "D66D1BB6D1B1D",
            "1BB1BBBB1BBB1",
            "BBBBBBBBBBBBB",
            "9BABBBBBABBBB",
            "BBAAABBBAAAB9",
            "BBBBAB9BBBABB",
            "BBBBBBBBBBBBB",
            "BBBBB33BBBBB8",
            "8BBB3DD3BBB8D",
            "D833DDDD333DD",
            "DDDDDDDDDDDDD",
        ),
        listOf( // Stage 31
            "DDDADDDDADDDD",
            "AADADAAAADAAA",
            "BB4DD4DDADABA",
            "BAAAAD9DD4BBB",
            "BBDADDADAAAAB",
            "AADADAADDADDD",
            "DD4B4D4BDADDA",
            "DAABAAAADB4DA",
            "4DD4DDADBBADA",
            "AADAADA4AAADD",
            "DD4DBBDDBADDA",
            "DAAABDDDDADAA",
            "DADDDDDDDDDDD",
        ),
        listOf( // Stage 32
            "CCCCCCCCCCCCC",
            "CCCCCCCCCCCCC",
            "CCC4CCCCC4CCC",
            "C4D4D4C4D4D4C",
            "C334DDDDD433C",
            "CCC4149414CCC",
            "9CCCD8D8DCCC9",
            "CCCCD1D1DCCCC",
            "CCCCD4D4DCCCC",
            "CCC4DD1DD4CCC",
            "C4C4D888D4C4C",
            "D414DDDDD414D",
            "D3DDDDDDDDD3D",
        ),
        listOf( // Stage 33
            "DDDD9DDDD9DDD",
            "D9DDD9DD9BBDD",
            "DD9DDDD9B67DD",
            "DDD9DBBBBBD5D",
            "D7DD9BB9BDD9D",
            "D87BD9BB9DD5D",
            "DDBBBBBDD9DDD",
            "D67BD9BDDD9DD",
            "DBBB9D9D6DD9D",
            "BBB9DDDD5DDDD",
            "DD9DDDDDDDD59",
            "DDDDDDDDD67DD",
            "7D6DDDDDDDDDD",
        ),
        listOf( // Stage 34
            "DDDD20DDDDDDD",
            "2220D2DD22DDD",
            "22244DDD242DD",
            "00D42DD0244DD",
            "D2D402D2444DD",
            "D20DD424004DD",
            "D2DD0442D24DD",
            "D0DD2442D24DD",
            "D033D444D2234",
            "D0DD024022200",
            "DD2D40244DD0D",
            "DD202DDD42D2D",
            "DD20DDDDD44DD",
        ),
        listOf( // Stage 35
            "DDDDDDDDDDDDD",
            "DDDD4D4DDDDDD",
            "BDDB4B4BDDBDD",
            "4BB44444BB4BD",
            "44449494444BD",
            "AAA44444AAABD",
            "A444444444AAB",
            "444A444A444BB",
            "44AAA4AAA44AA",
            "BAABBBBBAABAB",
            "DBBDDDDDBBDBD",
            "DDDDDDDDDDDDD",
            "DDDDDDDDDDDDD",
        ),
    )

    /** Spawn order of the 20 enemies of each stage. */
    val ROSTERS: List<String> = listOf(
        "BBBBBBBBBBBBBBBBBBFF", // 1
        "AAFFFFBBBBBBBBBBBBBB", // 2
        "BBBBBBBBBBBBBBFFFFAA", // 3
        "PPPPPPPPPPFFFFFBBAAA", // 4
        "PPPPPAABBBBBBBBFFFFF", // 5
        "PPPPPPPFFBBBBBBBBBAA", // 6
        "BBBFFFFPPPPPPBBBBBBB", // 7
        "PPPPPPPAAFFFFBBBBBBB", // 8
        "BBBBBBFFFFPPPPPPPAAA", // 9
        "BBBBBBBBBBBBFFPPPPAA", // 10
        "FFFFFAAAAAAPPPPFFFFF", // 11
        "PPPPPPPPFFFFFFAAAAAA", // 12
        "PPPPPPPPFFFFFFFFAAAA", // 13
        "PPPPPPPPPPFFFFAAAAAA", // 14
        "BBFFFFFFFFFFAAAAAAAA", // 15
        "BBBBBBBBBBBBBBBBFFAA", // 16
        "AAFFPPPPPPPPBBBBBBBB", // 17
        "AAAABBPPPPPPFFFFFFFF", // 18
        "FFFFAAAAAAAABBBBPPPP", // 19
        "FFFFFFFFBBPPAAAAAAAA", // 20
        "PPPPPPPPFFBBBBBBAAAA", // 21
        "FFFFFFFFBBBBBBPPAAAA", // 22
        "AAAAAAPPPPFFFFFFFFFF", // 23
        "PPPPAAFFFFBBBBBBBBBB", // 24
        "PPFFFFFFFFAAAAAAAAAA", // 25
        "FFFFFFAAAAAABBBBPPPP", // 26
        "PPAAAAAAAAFFFFFFFFBB", // 27
        "FFABBBBBBBBBBBBBBBPP", // 28
        "PPPPPPPPPPFFFFAAAAAA", // 29
        "BBBBFFFFFFFFPPPPAAAA", // 30
        "PPPFFFFFFFFAAAAAAPPP", // 31
        "AAAAAAAABBBBBBPPFFFF", // 32
        "FFFFAAAAAAAAPPPPFFFF", // 33
        "PPPPFFFFFFFFFFAAAAAA", // 34
        "PPPPFFFFFFAAAAAAAAAA", // 35
    )

    /** Fingerprint of the tables above, checked by StageDataTest so accidental edits are caught. */
    const val SHA256 = "e734ad3d4e7d6de68f889aed29306a529a5a4d5ed1f369f3d356e91d5c7469c3"
}
